
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.4494 1.70202C16.721 1.24933 16.612 0.684832 16.2059 0.441174C15.7998 0.197517 15.2504 0.366969 14.9788 0.819656L14.2706 2L13.0706 4L9.64052 9.71676L7.07057 14L5.87057 16L4.67058 18L4.49177 18.298C4.22016 18.7507 4.32918 19.3152 4.73528 19.5588C5.14137 19.8025 5.69076 19.633 5.96238 19.1803L6.67058 18H18.125C19.1605 18 20 17.1046 20 16V4C20 2.89542 19.1605 2 18.125 2H16.2706L16.4494 1.70202ZM15.0706 4L13.0918 7.29794L16.25 10.6667V14H9.07058L7.87058 16H17.8906C17.9528 16 18.0124 15.9737 18.0564 15.9268C18.1003 15.8799 18.125 15.8163 18.125 15.75V4.25C18.125 4.1837 18.1003 4.12011 18.0564 4.07322C18.0124 4.02634 17.9528 4 17.8906 4H15.0706ZM1.875 2H12.2706L11.0706 4H2.10938C2.04721 4 1.9876 4.02634 1.94365 4.07322C1.89969 4.12011 1.875 4.1837 1.875 4.25V15.75C1.875 15.8163 1.89969 15.8799 1.94365 15.9268C1.9876 15.9737 2.04721 16 2.10938 16H3.87056L2.67056 18H1.875C0.839453 18 0 17.1046 0 16V4C0 2.89542 0.839453 2 1.875 2ZM5.95645 10.3535L6.75034 11.2004L5.07056 14H3.75V12L5.29352 10.3535C5.4766 10.1583 5.7734 10.1583 5.95645 10.3535ZM5 5.66667C4.13707 5.66667 3.4375 6.41288 3.4375 7.33333C3.4375 8.25379 4.13707 9 5 9C5.86293 9 6.5625 8.25379 6.5625 7.33333C6.5625 6.41288 5.86293 5.66667 5 5.66667Z"}})])
          )
        }
      }
    